common.View.create('crud::helpers.pagination.Scroll', {

    onDOMLoad() {
        this.initPagination();
    },

    initPagination()
    {
        this.element.find('ul.pagination').hide();

        let currentPage = this.element.find('.pageNumber').val() || 1;

        this.element.jscroll({
            autoTrigger: true,
            padding: 0,
            nextSelector: '.pagination li.active + li a',
            contentSelector: 'div.scrolling-pagination',
            callback: () => {
                currentPage++;
                this.element.find('.pageNumber').val(currentPage);

                this.element.find('ul.pagination').remove();
            }
        });
    }

});